import { useState } from 'react';
import { MP_CF_QALBOX_COURSE_FAQ } from '../../../../Constants';

export const useSyncToProdFaq = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const syncProdFaqHook = async (faq, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_PROD_SYNC_URL}${MP_CF_QALBOX_COURSE_FAQ}/sync/prod`,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify({faq: faq}),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to sync to prod Faq (status ${response.status})`);
      }

      setSuccess(true);
      handleUpdate();
    } catch (err) {
      console.error(err);
      setError(err.message || 'An error occurred while syncing to prod Faq');
    } finally {
      setLoading(false);
    }
  };

  return [ syncProdFaqHook, loading, error, success ];
};